// タイムチャージ型 時間整形
$(() => {
    if (document.getElementById('notification-users') != null) {
        $(".js-notification-users").select2({
            maximumSelectionLength: 5,
            language: {
                maximumSelected: function (args) {
                    var message = '通知先は'+args.maximum+'人までです。';
                    return message;
                },
            }
        });
    }
});
